import { getUserInfo as _getUserInfo } from '@/api/login'
import { IUserInfoVo, T_userInfo } from '@/types'
import { defineStore } from 'pinia'
import { ref } from 'vue'

// 初始化状态
const userInfoState: IUserInfoVo = {
  token: '',
  detail: {
    id: null,
    avatarImg: '/static/images/default-avatar.png',
  },
  cartQuantity: 0,
  pickUp: null,
}

export const useUserStore = defineStore(
  'user',
  () => {
    // 定义用户信息
    const userInfo = ref<IUserInfoVo>({ ...userInfoState })
    // 设置用户信息
    const setUserInfo = (val: T_userInfo) => {
      console.log('设置用户信息', val)

      Object.assign(userInfo.value.detail, val)
      console.log('设置完的: ', userInfo.value)
    }
    // 删除用户信息
    const removeUserInfo = () => {
      userInfo.value = { ...userInfoState }
    }

    /**
     * 获取用户信息
     */
    const getUserInfo = async () => {
      console.log('获取用户信息')

      const res = await _getUserInfo()
      const userInfo = res.data
      setUserInfo(userInfo)
      // TODO 这里可以增加获取用户路由的方法 根据用户的角色动态生成路由
      return res
    }
    /**
     * 退出登录 并 删除用户信息
     */
    const logout = async () => {
      //   _logout()
      removeUserInfo()
    }

    const setCartQuantity = (num: number) => {
      userInfo.value.cartQuantity = num
    }

    // 设置默认自提点
    const setDefaultPickup = (data: { id: number; pointName: string }) => {
      userInfo.value.pickUp = data
    }

    return {
      userInfo,
      getUserInfo,
      setUserInfo,
      logout,
      setCartQuantity,
      setDefaultPickup,
    }
  },
  {
    persist: true,
  },
)
